<template>
    <transition name="cart">
        <div class="border shadow-lg p-xl rounded mb-xl">
            <div class="flex flex-col md:flex-row justify-between">
                <div class="flex items-center">
                    <font-awesome-icon :icon="['fal', 'check-circle']" class="text-success text-2xl mr-lg" />
                    <p class="mb-0">
                        <slot>
                            {{ lang('Din produkt är tillagd i varukorgen','The product have been added to your cart') }}
                        </slot>
                    </p>
                </div>
                <div class="flex flex-col md:flex-row">
                    <slot name="extra-button" />
                    <div v-if="showCartButton" class="mt-md md:mt-0">
                        <a :href="route('front.order.create')" class="btn btn-md is-primary">
                            {{ lang('Gå till kassan','Go to checkout') }}
                        </a>
                    </div>
                </div>
            </div>
            <slot name="info-section" />
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            showCartButton: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
    };
</script>
